import React, { useState } from "react";
import { Link } from "react-router-dom";
import { limitText } from "../../Utility/Utility";
import TagManager from 'react-gtm-module';
import YouTube from "react-youtube";
import { Img } from "../../Components/UI/UI";

export const WebinarsItem = (props) => {
  const desc = props.desc != undefined ? props.desc : "";
  const imgVideo = props.imgVideo != undefined ? props.imgVideo : "";
  const id = props.id != undefined ? props.id : "";
  const vidId = props.vidId != undefined ? props.vidId : "";
  const [isHover, setIsHover] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  let cancelCoverCss;

  const youTubeOptions = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      muted: 1,
      controls: 1,
      loopPlaylists: true,
      loop: 1,
      playlist: props.vidId,
    },
  };

  if (isClicked) {
    cancelCoverCss = " ac-cover-hide";
  } else {
    cancelCoverCss = " ";
  }

  return (
    <div
      className={"ac-wrapper-webinarsitem ac-wrapper-webinarsitem-" + id}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="ac-pic-video-content">
        <button
          className={"ac-pic-wrapper" + cancelCoverCss}
          onClick={(event) => {
            setIsClicked(true);
            // event.target.playVideo();
            TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'resources', 'click_cta':desc, 'event_details':'Webinars',}});
          }}
        >
          <Img desktopImg={imgVideo} imgCss={"ac-cover-video-img"} />
          <Img
            desktopImg={"Resources/White-play.svg"}
            imgCss={"ac-play-icon"}
          />
        </button>
        <div className="responisve-iframe">
          <YouTube
            videoId={vidId}
            opts={youTubeOptions}
            onReady={(event) => {
              // event.target.unmute();
              // event.target.playVideo();
              event.target.stopVideo();
            }}
          />
        </div>
      </div>
      <p>{limitText(desc, 100)}</p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Components/Webinars/WebinarsItem.js